import React from 'react';
import { useTranslation } from 'react-i18next';
import './Header.css';
import { images } from '../../constants';

/* Su mobile si servono ritagli verticali dedicati (3:4) */
const slides = [
  { desktop: images.gallery06, mobile: images.gallery06Mobile },
  { desktop: images.gallery01, mobile: images.gallery01Mobile },
  { desktop: images.gallery08, mobile: images.gallery08Mobile },
];

const Header = () => {
  const { t } = useTranslation();
  const [current, setCurrent] = React.useState(0);
  /* Su mobile l'altezza va congelata in pixel: Brave ricalcola svh quando le sue
     barre si ritirano e l'hero si ridimensionerebbe (effetto zoom sulle foto).
     Misuriamo una volta al caricamento e ricalcoliamo solo alla rotazione. */
  const [fixedHeight, setFixedHeight] = React.useState(null);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, []);

  React.useEffect(() => {
    const freeze = () => {
      if (window.innerWidth <= 650) {
        setFixedHeight(Math.round(window.innerHeight * 0.96));
      } else {
        setFixedHeight(null);
      }
    };
    freeze();
    const onOrientation = () => setTimeout(freeze, 300);
    window.addEventListener('orientationchange', onOrientation);
    return () => window.removeEventListener('orientationchange', onOrientation);
  }, []);

  return (
    <header
      className="app__header"
      id="home"
      style={fixedHeight ? { height: `${fixedHeight}px` } : undefined}
    >
      {slides.map((slide, index) => (
        <picture key={slide.desktop}>
          <source media="(max-width: 650px)" srcSet={slide.mobile} />
          <img
            src={slide.desktop}
            alt=""
            className={`app__header-slide ${index === current ? 'app__header-slide--active' : ''}`}
            loading={index === 0 ? 'eager' : 'lazy'}
          />
        </picture>
      ))}

      <div className="app__header-scrim" />

      <div className="app__header-content">
        <div className="app__header-panel">
          <h1 className="app__header-title">{t('welcome')}</h1>
          <p className="app__header-subtitle">{t('home')}</p>
          <a href="https://wa.me/+393713501881" target="_blank" rel="noreferrer">
            <button type="button" className="custom__button">{t('book')}</button>
          </a>
        </div>
      </div>

      <div className="app__header-dots">
        {slides.map((src, index) => (
          <button
            key={src}
            type="button"
            aria-label={`Slide ${index + 1}`}
            className={`app__header-dot ${index === current ? 'app__header-dot--active' : ''}`}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>
    </header>
  );
};

export default Header;
